"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** 打造一个类似 react 的 useEffect 的玩意儿，不同的是你要每次都按需触发一下 */
function makeEffectStub(fn) {
    let lastArgs = null;
    let lastCleanupFn = undefined;
    const doCleanup = () => {
        if (typeof lastCleanupFn !== 'function')
            return;
        lastCleanupFn();
        lastArgs = null;
        lastCleanupFn = undefined;
    };
    const effectStub = (...args) => {
        const changed = !lastArgs || lastArgs.length !== args.length || lastArgs.some((it, idx) => it !== args[idx]);
        if (changed) {
            doCleanup();
            lastArgs = args;
            lastCleanupFn = fn(...args);
        }
    };
    effectStub.cleanup = doCleanup;
    return effectStub;
}
exports.default = makeEffectStub;
//# sourceMappingURL=makeEffectStub.js.map